var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExcellence(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M10.442-19.783a8.826,8.826,0,0,1,3.993.967,7.363,7.363,0,0,1,2.945,2.5,8.633,8.633,0,0,1,1.3,3.415,22.34,22.34,0,0,1,.289,4.264H4.788A8.276,8.276,0,0,0,6.179-3.911a4.658,4.658,0,0,0,4.029,1.78,5.208,5.208,0,0,0,4.065-1.68A5.664,5.664,0,0,0,15.5-6.07h3.2a6.735,6.735,0,0,1-.84,2.376,8.45,8.45,0,0,1-1.6,2.141A7.578,7.578,0,0,1,12.592.4,11.141,11.141,0,0,1,9.937.687,8.149,8.149,0,0,1,3.812-1.942Q1.3-4.571,1.3-9.3a11.121,11.121,0,0,1,2.529-7.57A8.344,8.344,0,0,1,10.442-19.783Zm5.185,8.563a8.425,8.425,0,0,0-.921-3.378,4.722,4.722,0,0,0-4.462-2.349,4.946,4.946,0,0,0-3.758,1.617,6.108,6.108,0,0,0-1.608,4.11Z",
    transform: "translate(2 22)",
    fill: "#5b788f",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcellence);
export default __webpack_public_path__ + "static/media/icon_excellence.2f6dd87faa91d8ed6d4e0115c5b57f78.svg";
export { ForwardRef as ReactComponent };